import { Button, Collapse, Paper, Text } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import React from 'react'

import { Icons } from 'src/common/components/ui'

import styles from './collapsible-section.module.scss'

const CollapsibleSection = ({
  header,
  children,
  open = false,
}: {
  header: React.ReactNode
  children?: React.ReactNode
  open?: boolean
}) => {
  const [opened, { toggle }] = useDisclosure(open)

  return (
    <Paper mb={32}>
      <Button
        onClick={toggle}
        variant="transparent"
        mod={{ opened: opened }}
        className={styles['right-arrow-icon']}
        leftSection={<Icons.ArrowRight height={16} width={9} />}
      >
        <Text fz={18} c={'var(--mantine-color-blue-5)'} fw="bold">
          {header}
        </Text>
      </Button>
      <Collapse
        in={opened}
        transitionDuration={500}
        transitionTimingFunction="linear"
        mt={20}
      >
        {children}
      </Collapse>
    </Paper>
  )
}

export default CollapsibleSection
